// extracted by mini-css-extract-plugin
export default {"pwdRiskRoot":"style_pwdRiskRoot__1ffYa","item":"style_item__2xLFt","checked":"style_checked__2UJFU","unchecked":"style_unchecked__JWOWS","warning":"style_warning__1s34j"};